import type { ReactNode } from 'react';
import { LockKeyhole, ShieldAlert } from 'lucide-react';
import { useAuth } from './AuthProvider';
import { LanguageSwitcher, t, useI18n } from '../i18n';

export function AuthBoundary({ children }: { children: ReactNode }) {
  const { status, login, logout } = useAuth();
  useI18n();

  if (status === 'authorized') return children;
  if (status === 'loading') return <div className="auth-screen"><div className="spinner" aria-label={t('auth.checking')} /></div>;

  const forbidden = status === 'forbidden';
  const configError = status === 'config-error';
  return (
    <main className="auth-screen">
      <section className="auth-card">
        <img src="/aruha-mark.png" alt="Aruha" />
        {forbidden ? <ShieldAlert size={28} /> : <LockKeyhole size={28} />}
        <h1>{forbidden ? t('auth.forbiddenTitle') : configError ? t('auth.configTitle') : t('auth.privateTitle')}</h1>
        <p>
          {forbidden
            ? t('auth.forbiddenText')
            : configError
              ? t('auth.configText')
              : t('auth.signInText')}
        </p>
        {forbidden && <button className="primary-button" onClick={() => void logout()}>{t('auth.otherAccount')}</button>}
        {status === 'unauthenticated' && <button className="primary-button" onClick={() => void login()}>{t('auth.signIn')}</button>}
        <LanguageSwitcher />
      </section>
    </main>
  );
}
